const auth: {
  token: string | null
} = {
  token: null,
}

export default { auth }
